// export const GARBAGE = 'Garbage';
// export const YARD = 'Yard';
// export const RECYCLING = 'Recycling';
// export const BRUSH = 'Brush';
// export const COUNCIL = 'Council District';
// export const SUPER = 'Super District';
// export const FIRE = 'Fire District';

const Titles = {
  GARBAGE: 'Garbage',
  YARD: 'Yard',
  RECYCLING: 'Recycling',
  BRUSH: 'Brush',
  COUNCIL: 'Council District',
  SUPER: 'Super District',
  FIRE: 'Fire District',
};

export default Titles;
